<p-fluid>
  <form [formGroup]="eventForm" class="flex flex-col gap-4 mt-2 mb-4">
    <p-floatlabel variant="on">
      <input
        pInputText
        formControlName="name"
        [invalid]="eventForm.controls.name.invalid && eventForm.controls.name.touched"
        autocomplete="off"
      />
      <label>{{ 'internal.events.name' | translate }}</label>
    </p-floatlabel>

    <p-togglebutton
      formControlName="isPublic"
      [onLabel]="'internal.events.public' | translate"
      [offLabel]="'internal.events.private' | translate"
    />

    <div class="flex flex-row gap-4 justify-between flex-desktop">
      <div>
        <label>{{ 'internal.events.startDate' | translate }}</label>
        <p-datepicker
          formControlName="startdate"
          [invalid]="eventForm.controls.startdate.invalid && eventForm.controls.startdate.touched"
          showIcon
          iconDisplay="input"
          [showTime]="true"
          [inline]="true"
          [showButtonBar]="true"
          hourFormat="24"
        />
      </div>

      <div>
        <label>{{ 'internal.events.endDate' | translate }}</label>
        <p-datepicker
          formControlName="enddate"
          [invalid]="eventForm.controls.enddate.invalid && eventForm.controls.enddate.touched"
          showIcon
          iconDisplay="input"
          [minDate]="eventForm.value.startdate"
          [showTime]="true"
          [inline]="true"
          [showButtonBar]="true"
          hourFormat="24"
        />
      </div>
    </div>

    <div class="flex flex-col gap-4 flex-mobile">
      <p-floatlabel variant="on">
        <p-datepicker
          formControlName="startdate"
          [invalid]="eventForm.controls.startdate.invalid && eventForm.controls.startdate.touched"
          showIcon
          iconDisplay="input"
          [showTime]="true"
          [touchUI]="true"
          [showButtonBar]="true"
          hourFormat="24"
        />
        <label>{{ 'internal.events.startDate' | translate }}</label>
      </p-floatlabel>

      <p-floatlabel variant="on">
        <p-datepicker
          formControlName="enddate"
          [invalid]="eventForm.controls.enddate.invalid && eventForm.controls.enddate.touched"
          showIcon
          iconDisplay="input"
          [minDate]="eventForm.value.startdate"
          [showTime]="true"
          [touchUI]="true"
          [showButtonBar]="true"
          hourFormat="24"
        />
        <label>{{ 'internal.events.endDate' | translate }}</label>
      </p-floatlabel>
    </div>

    <p-floatlabel variant="on">
      <input
        pInputText
        formControlName="location"
        [invalid]="eventForm.controls.location.invalid && eventForm.controls.location.touched"
        autocomplete="off"
      />
      <label>{{ 'internal.events.location' | translate }}</label>
    </p-floatlabel>

    <div class="flex flex-row gap-4 flex-mobile-col">
      <p-floatlabel variant="on" class="w-full">
        <input
          pInputText
          formControlName="contact"
          [invalid]="eventForm.controls.contact.invalid && eventForm.controls.contact.touched"
          autocomplete="off"
        />
        <label>{{ 'internal.events.contact' | translate }}</label>
      </p-floatlabel>

      <p-floatlabel variant="on" class="w-full">
        <input
          pInputText
          formControlName="contactMail"
          [invalid]="
            eventForm.controls.contactMail.invalid && eventForm.controls.contactMail.touched
          "
          autocomplete="off"
        />
        <label>{{ 'internal.events.contactMail' | translate }}</label>
      </p-floatlabel>
    </div>

    <p-floatlabel variant="on">
      <textarea
        pTextarea
        formControlName="equipment"
        [invalid]="eventForm.controls.equipment.invalid && eventForm.controls.equipment.touched"
        rows="10"
        cols="30"
        style="resize: none"
        class="h-full"
      ></textarea>
      <label>{{ 'internal.events.equipment' | translate }}</label>
    </p-floatlabel>

    <p-floatlabel variant="on">
      <textarea
        pTextarea
        formControlName="description"
        [invalid]="eventForm.controls.description.invalid && eventForm.controls.description.touched"
        rows="10"
        cols="30"
        style="resize: none"
        class="h-full"
      ></textarea>
      <label>{{ 'internal.events.description' | translate }}</label>
    </p-floatlabel>
  </form>
</p-fluid>

<div class="flex justify-end gap-2">
  @if (event._id != undefined && hasPerm('delete_events')) {
    <p-button [label]="'general.delete' | translate" severity="danger" (onClick)="deleteEvent()" />
  }
  <p-button [label]="'general.cancel' | translate" severity="secondary" (onClick)="closeDialog()" />
  <p-button
    [label]="'general.save' | translate"
    [disabled]="!eventForm.valid"
    (onClick)="closeDialog(true)"
  />
</div>
